<template>
  <BaseLayout @click-back="back" isFunction="true" hasBottomButton="true" hasHeaderBar="true">
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">訂單編號</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.OrderNoStartForSearch" />
      <div class="input-group-prepend">
        <div class="input-group-text">~</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.OrderNoEndForSearch" />
    </div>

    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">客戶交期</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.DueDateStartForSearch" />
      <div class="input-group-prepend">
        <div class="input-group-text">~</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.DueDateEndForSearch" />
    </div>

    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">客戶編號</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.CustomerIdStartForSearch" />
      <div class="input-group-prepend">
        <div class="input-group-text">~</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.CustomerIdEndForSearch" />
    </div>

    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">客戶訂單</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.CustomerOrderNoStartForSearch" />
    </div>

    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">業務部門</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.SalesDepartmentStartForSearch" />
    </div>

    <div class="list-group" style="text-align: left;">
      <template v-for="(item,index) in gridData">
        <div :key="item.ItemNo" class="list-group-item list-group-item-action">
          <div
            class="d-flex w-100 justify-content-between"
            style=" background:#EEE; padding: 5px 5px 0px 5px"
          >
            <b class="mb-1">
              <!-- <i class="fas fa-building"></i> -->
              訂單: {{item.OrderNoFull}}
            </b>
            <h5
              class="badge badge-success"
              style="width:50%; 
              overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
     word-break: break-all;"
            >客戶: {{item.CustomerAbbreviation}}</h5>
          </div>
          <div class="d-flex flex-row justify-content-between">
            <span class="badge badge-light">客戶訂單: {{item.CustomerOrderNo}}</span>
            <span class="badge badge-light">客戶交期:{{item.DueDate}}</span>
          </div>
          <div class="d-flex flex-row">
            <span class="badge badge-light">品名:{{item.ItemDescription}}</span>
          </div>
          <div class="d-flex flex-row">
            <span class="badge badge-light">數量:{{item.OrderQuantity}}</span>
            <span class="badge badge-light">單價:{{item.TradePrice}}</span>
          </div>
          <small
            v-if="item.SalesDepartmentId"
            style="color:#888;float:right;"
          >業務部門: {{item.SalesDepartmentId}}</small>
          <!-- <small style="float:right; color:#888;">
            <i class="fas fa-user"></i>
            {{form.EmployeeName}}
          </small>-->
        </div>
      </template>
    </div>

    <button @click="query" type="button" class="btn-xl btn btn-primary btn-circle">
      <i class="fas fa-search"></i>
    </button>
  </BaseLayout>
</template>
<script>
export default {
  name: "OrderDetailList",
  data: function() {
    var today = new Date();
    var lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);
    var firstDayInPreviousMonth = function() {
      var d = new Date();
      d.setDate(1);
      d.setMonth(d.getMonth() - 1);
      return d;
    };

    var data = {
      searchData: {
        companyId: this.$store.state.companyId,
        CustomerIdStartForSearch: "",
        CustomerIdEndForSearch: "",
        CustomerOrderNoStartForSearch: "",
        // CustomerOrderNoEndForSearch:'',
        startYearMonth: firstDayInPreviousMonth()
          .toISOString()
          .slice(0, 7), //.toISOString().slice(0, 5) + "01",
        endYearMonth: new Date().toISOString().slice(0, 10),
        DueDateStartForSearch: firstDayInPreviousMonth()
          .toISOString()
          .slice(0, 10),
        DueDateEndForSearch: lastDayOfMonth.toISOString().slice(0, 10),
        // ItemNoStartForSearch:'',
        // ItemNoEndForSearch:'',
        OrderNoStartForSearch: "",
        OrderNoEndForSearch: "",
        // RelationCustomerIdStartForSearch:'',
        // RelationCustomerIdEndForSearch:'',
        SalesDepartmentStartForSearch: ""
        // SalesDepartmentEndForSearch:'',
        // IsPrintNotShip:'N',
        // SortTypeCode:'',
        // SortSizeCode:''
      },
      gridData: []
    };
    return data;
  },
  methods: {
    back: function() {
      this.$router.go(-1);
    },
    query: function() {
      var _this = this;
      this.startLoad();
      _this.$http
        .post("/WebApp/OrderDetailList/Query", {
          ...this.searchData
        })
        .then(res => {
          _this.gridData = res.data;
          _this.gridData.forEach(v => {
            let setDate = dateName => {
              if (v[dateName]) {
                var d = new Date(parseInt(v[dateName].substr(6)));
                v[dateName] =
                  d.getFullYear() +
                  "-" +
                  (d.getMonth() + 1) +
                  "-" +
                  d.getDate();
              }
            };
            setDate("DueDate");
          });
          _this.endLoad();
        })
        .catch(err => {
          _this.endLoad();
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-circle.btn-xl {
  position: fixed;
  bottom: 10px;
  right: 10px;
  width: 70px;
  height: 70px;
  padding: 10px 16px;
  border-radius: 35px;
  font-size: 24px;
  line-height: 1.33;
}
.btn-circle {
  width: 30px;
  height: 30px;
  padding: 6px 0px;
  border-radius: 15px;
  text-align: center;
  font-size: 12px;
  line-height: 1.42857;
}
.input-group > .input-group-prepend:first-child > .input-group-text {
  width: 5.8rem;
}
input[type="date"] {
  padding: 0;
}
</style>